import { Injectable } from '@angular/core';
import { NetworkingService } from '../networking.service';
import { SharedDataService } from '../../helper/services/shared-data.service';
import { API } from '../../data/api';
import { Router } from '@angular/router';
import { HelperService } from '../../helper/services/helper.service';

@Injectable({
  providedIn: 'root'
})
export class CourseManagerService {
  constructor(private networkingService: NetworkingService, private helperService: HelperService, private router: Router) { }

  async login(payload: {
    email: any,
    password: any
  }): Promise<any>{
    return new Promise<any>((resolve) => {
      this.networkingService.postRequest(API.courseManagerLogin, payload).subscribe((response) => resolve(response))
    })
  }

  async logoutUser(){
    this.helperService.clearLocalStorage()
    sessionStorage.clear()
    this.logout()
      .then(_ => this.router.navigate(['dashboard'])
        .then(_ => location.reload()))
  }

  private async logout(): Promise<any>{
    return new Promise<any>((resolve) => {
      this.networkingService.postRequest(API.courseManagerLogout).subscribe((response) => resolve(response))
    })
  }

  async resetPassword(email: string): Promise<any> {
    const payload = { email };
  
    return new Promise<any>((resolve, reject) => {
      this.networkingService.putRequest(API.courseManagerResetPassword, payload).subscribe({
        next: (response) => resolve(response),
        error: (error) => reject(error)
      });
    });
  }
  
  async changePasswordAfterReset(auth_token: string, newPassword: string): Promise<any> {
    const payload = {
      auth_token,
      new_password: newPassword
    };
  
    return new Promise<any>((resolve, reject) => {
      this.networkingService.putRequest(API.courseManagerAlterPassword, payload).subscribe({
        next: (response) => resolve(response),
        error: (error) => reject(error)
      });
    });
  }
}
